import {
  addServiceCookie,
  deleteServiceCookie,
  getServicesCookie,
  isServiceExist,
  updateServiceCookie,
} from 'utils/services';
import { dispatchEvent } from 'utils/common';
import { logEvent } from '../helpers';
import { BASKET_EVENT_UPDATE_SERVICE } from '../consts';
import type { BasketSetServiceEventArg, ServiceCookie } from '../../../../../types/services';
import { servicesGuard } from '../../../../../types/guards';

function isBasketSetServiceEvent(e: Event): e is CustomEvent<BasketSetServiceEventArg> {
  if (!('detail' in e)) return false;

  return servicesGuard(e.detail as ServiceCookie);
}

export const handleBasketSetService = (e: Event) => {
  if (isBasketSetServiceEvent(e)) {
    logEvent('basket:set_service', e.detail);

    if (e.detail.quantity === 0) {
      deleteServiceCookie(e.detail);
    } else if (isServiceExist(e.detail)) {
      updateServiceCookie(e.detail);
    } else {
      addServiceCookie(e.detail);
    }

    const services = getServicesCookie() || [];

    dispatchEvent(BASKET_EVENT_UPDATE_SERVICE, services);
  } else {
    console.error('Invalid arguments in basket:set_service event');
  }
};
